import React from 'react';
import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, className = '', ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ label, title, subtitle, dark = false, align = 'center' }) => (
  <Reveal className={`mb-12 md:mb-16 ${align === 'center' ? 'text-center mx-auto' : ''} max-w-3xl`}>
    {label && (
      <div className={`text-xs font-bold uppercase tracking-[0.2em] mb-4 ${dark ? 'text-[#4DA3FF]' : 'text-[#0066CC]'}`}>
        {label}
      </div>
    )}
    <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-semibold leading-snug font-heading ${dark ? 'text-white' : 'text-[#0A192F]'}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-4 text-base leading-relaxed ${dark ? 'text-slate-400' : 'text-slate-600'}`}>{subtitle}</p>}
  </Reveal>
);
